import React, {ReactElement} from 'react';
import mergeClasses from "../../../utils/merge-classes.ts";
import {BTN_BASE, BTN_SIZES, BTN_VARIANTS, ButtonSize, ButtonVariant} from "../button-const.ts";

type ButtonToggleVariant = Exclude<ButtonVariant, 'project'>;

interface ButtonToggleProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
    variant?: ButtonToggleVariant;
    size?: ButtonSize;
    
    type?: 'button' | 'submit' | 'reset';
    
    toggled: boolean;
    setIsToggled: (toggled: boolean) => void;
    redoToggleAction?: boolean;
}

const BTN_VARIANTS_TOGGLE: Record<ButtonToggleVariant, string> = {
    primary: 'data-[toggled=true]:bg-indigo-600 data-[toggled=true]:text-white data-[toggled=true]:hover:bg-indigo-500',
    success: 'data-[toggled=true]:bg-green-600 data-[toggled=true]:text-white data-[toggled=true]:hover:bg-green-500',
    danger: 'data-[toggled=true]:bg-red-600 data-[toggled=true]:text-white data-[toggled=true]:hover:bg-red-500',
    warning: 'data-[toggled=true]:bg-yellow-500 data-[toggled=true]:text-white data-[toggled=true]:hover:bg-yellow-600',
    simple: 'data-[toggled=true]:bg-stone-200 data-[toggled=true]:hover:bg-stone-300',
    ghost: 'data-[toggled=true]:bg-gray-100 data-[toggled=true]:hover:bg-stone-200',
}

const ToggleButton = ({toggled, setIsToggled, redoToggleAction = false, type = 'button', variant = 'primary', size = 'sm', className, onClick, ...props }: ButtonToggleProps): ReactElement => (
        <button
            data-toggled={toggled}
            onClick={(e) => {
                if (toggled && redoToggleAction) {
                    setIsToggled(true);
                    onClick?.(e);
                    return;
                }

                setIsToggled(!toggled);
            }}
            className={mergeClasses(BTN_BASE, BTN_VARIANTS[variant], BTN_VARIANTS_TOGGLE[variant], BTN_SIZES[size], className)}
            {...props}
            type={type}
        />
    );

export default ToggleButton;